module.exports = __webpack_public_path__ + "static/img/1-3.b53d8f13.png";